// extracted by mini-css-extract-plugin
module.exports = {"sideCards":"TimedRoundModules_sideCards__11IKw","timelineContainer":"TimedRoundModules_timelineContainer__3fIYe"};